<app-data-grid
  [mode]="'edit'"
  *ngIf="restaurantIds && restaurantIds.length > 0"
  [state]="state"
  [fontSize]="fontSize"
  (valueChange)="cacheChanges()"
  [columns]="columns"
  [dataItems]="changeset"
  [filterable]="'menu'"
  (dataStateChange)="fetchChangesets($event)"
  (filterChange)="filterChanged($event)"
>
  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="itemName"
  >
    <app-custom-filter
      [view]="type"
      [restaurantId]="restaurantId"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      [productType]="productTypeId"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="parItemId"
  >
    <app-custom-filter
      [view]="type"
      [restaurantId]="restaurantId"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      [productType]="productTypeId"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="plu"
  >
    <app-custom-filter
      [view]="type"
      [restaurantId]="restaurantId"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      [productType]="productTypeId"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    columnTemplate
    field="itemName"
    let-row="row"
    let-column="column"
  >
    <span class="k-d-flex k-gap-md k-align-items-center">
      <app-column [data]="row" [column]="column" [fontSize]="fontSize">
      </app-column>
      <button
        *ngIf="row.status == 'Pending Availability'"
        kendoButton
        [title]="'This item is pending sync to PAR'"
        class="m-l-4 info-bg badge-button"
        size="small"
        rounded="full"
      >
        Pending
      </button>

      <button
        *ngIf="row.hasDirty()"
        kendoButton
        [title]="'This item has unsaved changes'"
        class="m-l-4 warning-bg badge-button"
        size="small"
        rounded="full"
      >
        Unsaved
      </button>

      <button
        *ngIf="row.status == 'Scheduled Availability'"
        kendoButton
        [title]="'This item is scheduled to sync with PAR'"
        class="m-l-4 success-bg badge-button"
        size="small"
        rounded="full"
      >
        Scheduled
      </button>
    </span>
  </ng-template>

  <ng-template
    columnTemplate
    field="newDeliveryAvailability3P"
    let-row="row"
    let-column="column"
  >
  <div class="k-d-flex k-gap-md k-align-items-center">
    <app-editable-column
       [fontSize]="fontSize"
       [dataItem]="row"
       [column]="column"
       (valueChange)="onValueChange($event.dataItem, $event.field)"
       [disabled]="row.newAvailability == false"
     ></app-editable-column>
   
       <fa-icon
         kendoTooltip
         title="App/Delivery turns off when In Store is unavailable and restores your previous setting when reactivated."
         *ngIf="row.newAvailability == false"
         [icon]="['fas', 'exclamation-triangle']"
         class="text-warning"
       ></fa-icon>
  </div>
 </ng-template>

  <ng-template #noRecordsTemplate>
    <p *ngIf="!newFeatures.includes(productTypeId)">There is no data that matches the current filter settings.</p>
    <p *ngIf="newFeatures.includes(productTypeId)">This feature is coming soon for the selected tier. We will send a future communication with further details.</p>
</ng-template>
</app-data-grid>

<kendo-dialog
  *ngIf="showConfirmDialog"
  title="Confirm Bulk Action"
  (close)="onConfirmDialogClose()"
  [width]="600"
>
  <p style="white-space: pre-line">{{ confirmDialogMessage }}</p>

  <kendo-dialog-actions layout="end">
    <button kendoButton (click)="onConfirmDialogClose()">Cancel</button>
    <button kendoButton (click)="onConfirmDialogProceed()" themeColor="primary">
      Continue
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
